import { getColor, getSize, getWeight } from "views/resources/theme";
import styled from "styled-components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	background-color: ${getColor("bg")};
	padding: ${getSize("m")} ${getSize("l")};
	border-radius: ${getSize("m")} ${getSize("m")} 0 0;
	z-index: 9999;

	@media screen and (min-width: 768px) {
		& > div:first-child {
			margin: 0 auto;
		}
	}
`;

const Modulo = styled.div`
	margin: 0px;
	font-size: 28px;
	color: #145ab4;
	font-weight: bold;
`;

const Text = styled.div`
	margin: 3px 0px;
	font-size: 16px;
	font-weight: bold;
`;

export { Wrapper, Modulo, Text };
